<template>
  <div class="page-content transactionHistory">
    <h1 class="page-title">{{ $locale("sideMenu.reports.otherTransaction") }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :xs="24" :sm="24" :md="24" :lg="13" :xl="10">
        <el-row :gutter="10">
          <el-col :span="20">
            <DatePickerGroup
              class="date-group-container"
              v-bind:start="timeValue1"
              v-bind:end="timeValue2"
              @setFatherDate="getDate"
            ></DatePickerGroup>
          </el-col>
          <el-col :span="4">
            <el-button @click="search" class="egl-btn-yellow fixWidthBtn">{{$locale("global.search")}}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="11" :xl="14">
        <el-row :gutter="10" class="ta-r">
          <el-col :span="24">
            <el-button @click="exportCsv" class="egl-btn-yellow fixWidthBtn">{{
              $locale("global.exportToCSV")
            }}</el-button>
            <el-button class="egl-btn-yellow fixWidthBtn" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
            <!-- <el-button @click="printData" class="egl-btn-yellow fixWidthBtn">{{
              $locale("global.Print")
            }}</el-button> -->
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row :xs="24">
        <el-col :span="5">
            <el-input :placeholder="$locale('trans.koisk.search.p')" v-model="searchInput" @keyup.enter.native="search">
                <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                style="cusor: pointer;" @click="search"
                ></i>
            </el-input>
        </el-col>
    </el-row>

    <el-row :gutter="10" class="create-button-container">
      <el-col :span="5" :offset="19" class="ta-r">
        <el-button @click="toggle('create')" class="egl-btn-yellow fixWidthBtn"
          >{{ $locale("global.create") }}</el-button
        >
      </el-col>
    </el-row>

    <div class="table-module">
      <!-- <Table
        :title="table"
        :data="tableData"
        ref="father"
        :size="size"
        :currentPage="currentPage"
      /> -->
      <div id="print">
        <el-table
        class="egl-table list-table"
        style="width: 100%"
        :data="tableData"
        :stripe="true"
        ref="father"
        @filter-change="filter"
        @sort-change="sort_fn"
      >

        <el-table-column
          :column-key="item.columnKey && item.columnKey"
          v-for="(item, idx) in table"
          align="center"
          :key="idx"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :filters="item.filter && getFilterArr(item.filter)"
          :filtered-value="item.filter && getFilterArr(item.filter).map(_item => _item.value)"
          :sortable="item.prop === 'transactionCreateTime' && 'custom'"
          :formatter="item.formatter"
        ></el-table-column>

        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <div class="handle">
              <a @click="openDialog('info', scope.row.transactionId, scope.row.transactionItemId )">{{ $locale('global.detail') }}</a>
               <el-divider direction="vertical"></el-divider>
              <a @click="openDialog('edit', scope.row.transactionId, scope.row.transactionItemId )">{{ $locale('global.edit') }}</a>
              <!-- <el-divider direction="vertical"></el-divider> -->
                <!-- <a
                  @click="deleteRow(scope.row)"
                >{{ $locale('global.delete') }}</a> -->
            </div>
          </template>
        </el-table-column>
        </el-table>
      </div>
      <CommPagination
        :total="count"
        :curPage="currentPage"
        @current-change="pageChange"
      />
    </div>

    <Dialog
      :type="type"
      :visible="isOpen"
      :titleText="$locale(type === 'create' ? 'trans.other.transationOther' : 'trans.other.transationOtherDetail')"
      dialogWidth="1200px"
      :oneButton="type === 'info'"
      :closeAction="toggle"
      :confirmAction="submitCreateDialog"
      :btnText="$locale('global.update')"
      v-if="tableData"
    >
    <el-form :model="modalData" :rules="formRules" ref="ruleForm">
      <div class="section">
        <div class="sectionInner creat-popup-container">
            <div>
                <Card :title="$locale('trans.koisk.transid')" :content="detailData.searchId || '/'" />
            </div>
            <div class="date-container">
                <el-row :gutter="10">
                    <el-col :span="24" >

                        <Card v-if="type !== 'info'" title="日時" />
                        <Card v-else title="日時" :content="detailData.transactionCreateTime" />

                        <el-row :xs="24" :sm="18" :lg="24" v-if="type !== 'info'">
                            <el-col :span="24" class="date-container">
                              <el-form-item prop="date">
                                <CommDatePicker
                                  v-model="modalData.date"
                                  :value.sync="modalData.date"
                                  width="100%"
                                  :showWeekly="true"
                                  :pickerOptions="datePickerOptions"
                                />
                              </el-form-item>

                              <el-form-item prop="dateHour">
                                <el-input
                                  placeholder="例) 13"
                                  v-model="modalData.dateHour"
                                ></el-input>
                              </el-form-item>
                              <el-form-item prop="dateMin">
                                <el-input
                                  placeholder="例) 00）"
                                  v-model="modalData.dateMin"
                                ></el-input>
                              </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>
      </div>
      <hr class="dotted" />
      <div class="section">
        <div class="sectionInner">
          <div class="card">
            <div class="title">{{ $locale('inventoryLog.name') }}</div>
            <el-form-item prop="productValue" v-if="type !== 'info'">
              <el-select
                :placeholder="$locale('trans.other.selectProduct')"
                v-model="modalData.productValue"
                @change="productOnChange"
                value-key="value"
              >
                <el-option
                  v-for="(item) in productNameArr"
                  :key="item.value"
                  :label="item.text"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="content" v-else>{{ detailData.productName }}</div>
          </div>

          <div class="card">
            <div class="title">{{ $locale('global.quantity') }}</div>
            <el-form-item prop="quantity" v-if="type !== 'info'">
              <el-input
                :placeholder="$locale('trans.other.selectQuantity')"
                v-model.number="modalData.quantity"
                @change="quantityOnChange"
                @input="validateHandler"
              ></el-input>
            </el-form-item>
            <div class="content" v-else>{{ detailData.qty }}</div>
          </div>

          <Card :title="$locale('global.department')" :content="detailData.groupId || '/'" />
          <Card :title="$locale('trans.koisk.salesgroup')" :content="detailData.saleGroupId || '/'" />
        </div>
        <div class="sectionInner">
          <div class="card">
            <div class="title">{{ $locale('global.unitPrice') }}</div>

            <el-form-item prop="unitPrice" v-if="type !== 'info'">
              <el-input
                :placeholder="$locale('trans.other.selectUnitPrice')"
                v-model="modalData.unitPrice"
                @change="unitPriceOnChange"
              ></el-input>
            </el-form-item>
            <div class="content" v-else>{{ detailData.unitPrice }}</div>
          </div>

          <div class="card">
            <div class="title">{{ $locale('trans.other.price') }}</div>
            <el-form-item prop="price" v-if="type !== 'info'">
              <el-input
                :placeholder="$locale('trans.other.selectPrice')"
                v-model="modalData.price"
              ></el-input>
            </el-form-item>
            <div class="content" v-else>{{ detailData.totalAmount }}</div>
          </div>
          <Card :title="$locale('global.taxRate')" :content="type === 'create' ? taxRatesMap[modalData.taxRate] : taxRatesMap[detailData.taxRate]" />
        </div>
      </div>
      <hr class="dotted" />
      <div class="section">
        <div class="sectionInner">
          <Card title="姓（漢字）" :content="detailData.payerFirstNameHant || '/'" />
          <Card title="名（漢字）" :content="detailData.payerLastNameHant || '/'" />
          <Card title="姓（カタカナ)" :content="detailData.payerFirstNameSyl || '/'" />
          <Card title="名（カタカナ）" :content="detailData.payerLastNameSyl || '/'" />
        </div>
        <div class="sectionInner">
          <Card title="電話番号" :content="detailData.mobile || '/'" />
          <Card title="メールアドレス" :content="detailData.email || '/'" />
          <Card :title="$locale('trans.other.memberId')" :content="detailData.userId || '/'" />
        </div>
      </div>
      <hr class="dotted" />
      <div class="section">
        <div class="sectionInner">
          <div class="card">
            <div class="title">{{$locale("accountReceivable.clientTarget")}}</div>
            <el-form-item prop="clientId" v-if="type !== 'info'">
              <RemoteSelectV2
                ref="selectV2"
                type="client"
                :list="comClientList"
                v-model="modalData.clientId"
                :formValue.sync="modalData.clientId"
                :isMultiple="false"
              />
              <!-- <remote-select
                :isDisable="type !== 'create'"
                type="client"
                :isMultiple="false"
                v-model="modalData.clientId"
                :formValue.sync="modalData.clientId"
                :actionType="type"
              ></remote-select> -->
              <!-- <el-select
                :placeholder="$locale('trans.other.selectPaymentName')"
                v-model="modalData.paymentName"
              >
                <el-option
                  v-for="(item, index) in (type === 'create' ? paymentName : originPaymentName)"
                  :key="index"
                  :label="type === 'create' ? item.label : item.name"
                  :value="type === 'create' ? item.value : item.id"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <div class="content" v-else>{{ detailData.clientName || "/"}}</div>
          </div>

          <Card :title="$locale('global.status')" :content="'支払い済み'" />
          <Card title="デバイス/担当者" :content="detailData.userName || userName || '/'" />
        </div>
      </div>

      <!-- <div v-if="type === 'create'">
        <hr class="dotted" />
        <div class="section">
          <div class="sectionInner">
            <div class="card remark">
              <div class="title">コメント</div>
                <el-form-item>
                  <el-input
                    placeholder="コメントを選択してください"
                    v-model="modalData.remark"
                  ></el-input>
                </el-form-item>
            </div>
          </div>
        </div>
      </div> -->
    </el-form>
    </Dialog>
  </div>
</template>

<script>
import "@/assets/style/transactionHistory.less";
import Dialog from "@/components/Version/dialog.vue";
import Card from "@/components/Report/card.vue";
import moment from "moment";
import CommPagination from "@/components/common/CommPagination";
import DatePickerGroup from "@/components/DatePickerGroup";
import CommDatePicker from "@/components/common/CommDatePicker";
import exportToPrint from "@/helpers/exportToPrint";
import { requestAll } from "@/helpers/service/axiosPlugin";
import { delProductSalesReportService } from "@/helpers/service/api/report";
import { getOtherRevenueReport, createNewOtherRevenueRecord, getOtherRevenueRecordDetail, updateOtherRevenueRecordService } from "@/helpers/service/api/otherRevenue";
import { getPaymentTypeList } from "@/helpers/service/api/device";
import { getOtherRevenueList } from "@/helpers/service/api/accountPayable.js";
import { taxRatesMap, weekLocaleArray, formatStringFixed} from "@/utils/common";
import countDownAlert from "@/utils/countDownAlert";
import { exportCSV_fn } from "@/assets/js/transactionOther_exportCSV";
// import RemoteSelect from "@/components/common/RemoteSelect";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { NumberVa } from "@/utils/inputValidation"
import { getClientListService } from "@/helpers/service/api/common";

export default {
  components: {
    CommDatePicker,
    Dialog,
    Card,
    CommPagination,
    DatePickerGroup,
    // RemoteSelect,
    RemoteSelectV2,
  },
  computed: {
    today() {
      return this.$moment().startOf("day").valueOf();
    }
  },
  mounted() {
    const today = this.$moment().valueOf();
    this.timeValue1 = today;
    this.timeValue2 = today;

    if (this.cinemaId == "") {
      this.loading = false;
      this.$emit("callCinema", "getHistoryList");
      return;
    }

    this.getFormOption();
    this.getHistoryList();

    getClientListService({
      page: 0,
      pageSize: 20,
      field: ["id", "name"]
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.comClientList = res.data.data;
        // this.$refs["selectV2"].page = 0;
        // if (this.form.targetSourceList.clientIdList.length === 0) this.$refs["selectV2"].page++;
      }
    });
  },
  data() {
    const validatePass = (rule, value, callback) => {
      // if (value === "" || value < this.$moment().subtract(10, "days").valueOf()) {
      if (value === "") {
        callback(new Error("Invali Date"));
      }else{
        callback();
      }
    };

    const validateTime = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$locale("trans.plsInput.min")));
      }
      else if (value > 60 || value < 0 || isNaN(value)) {
        callback(new Error(this.$locale("trans.plsInput.validMin")));
      }else{
        callback();
      }
    };
    const validateTime_hour = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$locale("trans.plsInput.time")));
      }
      else if (value > 23 || value < 0 || isNaN(value)) {
        callback(new Error(this.$locale("trans.plsInput.validTime")));
      }else{
        callback();
      }
    };
    // const isRequired = [
    //   {
    //     required: true,
    //     message: "Please fill"
    //   }
    // ];
    const timeRules_H = [
      {
        validator: validateTime_hour,
        trigger: "blur"
      }
    ];
    const timeRules_M = [
      // {
      //   type: "number",
      //   message: "Please input number",
      // },
      {
        validator: validateTime,
        trigger: "blur"
      } ];

    return {
      cinemaId: window.localStorage.getItem("cinemaId") || "",
      accountId: window.localStorage.getItem("accountId") || "",
      userName: window.localStorage.getItem("userName") || "",
      timeValue1: 0,
      timeValue2: 0,
      sort: "",
      filters: [],
      productNameArr: [
        {
          value: "自販機収入",
          text: "自販機収入"
        },
        {
          value: "広告料収入",
          text: "広告料収入"
        },
        {
          value: "貸館収入",
          text: "貸館収入"
        }
      ],
      taxRateArr: [
        // {
        //   value: "10%",
        //   text: "10%"
        // },
        // {
        //   value: "20%",
        //   text: "20%"
        // },
        // {
        //   value: "30%",
        //   text: "30%"
        // }
        {
          text: this.$locale("trans.report.taxrate.map.non"),
          value: -1.1,
        },
        {
          text: this.$locale("trans.report.taxrate.map.zero"),
          value: 0,
        },
        {
          text: this.$locale("trans.report.taxrate.map.percenteight"),
          value: 0.08,
        },
        {
          text: this.$locale("trans.report.taxrate.map.percentTen"),
          value: 0.1,
        },
      ],
      table: [
        {
          prop: "searchId",
          label: this.$locale("trans.koisk.transid"),
          width: 220,
          formatter: (row, column, cellValue, index) => {
            return formatStringFixed(cellValue);
          }
        },
        {
          prop: "transactionCreateTime",
          label: this.$locale("global.date"),
          width: 234
        },
        {
          prop: "otherRevenueName",
          label: this.$locale("trans.other.productName"),
          width: 220,
          // filter: "productType",
          // columnKey: "productNameGp",
          // arr: [
          //   {
          //     value: "自販機収入",
          //     text: "自販機収入"
          //   },
          //   {
          //     value: "広告料収入",
          //     text: "広告料収入"
          //   },
          //   {
          //     value: "貸館収入",
          //     text: "貸館収入"
          //   }
          // ]
        },
        {
          prop: "unitPrice",
          label: this.$locale("global.unitPrice"),
          width: 170
        },
        {
          prop: "qty",
          label: this.$locale("global.quantity"),
          width: 120
        },
        {
          prop: "totalAmount",
          label: this.$locale("global.amount"),
          width: 170
        },
        {
          prop: "unit",
          label: this.$locale("global.unit"),
          width: 87
        },
        {
          prop: "taxRate",
          label: this.$locale("global.taxRate"),
          width: 170,
          filter: "taxRateType",
          columnKey: "taxRateGp"
        },
        {
          prop: "userName",
          label: this.$locale("inventoryLog.changePeople"),
          width: 170
        }
      ],
      tableData: [],
      type: "",
      transIndex: 0,
      searchInput: "",
      size: 10,
      currentPage: 0,
      originPaymentName: [],
      paymentName: [
        {
          label: "Visa",
          value: "Visa",
        },
        {
          label: "Master",
          value: "Master",
        },
        {
          label: "AE",
          value: "AE",
        }
      ],
      detailData: {},
      defaultModalData: {
        price: "",
        unitPrice: "",
        date: this.$moment().startOf("day").valueOf(),
        dateHour: null,
        dateMin: null,
        productValue: "",
        quantity: null,
        remark: "",
        paymentName: ""
      },
      modalData: {
        price: "",
        unitPrice: "",
        date: this.$moment().startOf("day").valueOf(),
        dateHour: null,
        dateMin: null,
        productValue: "",
        quantity: null,
        remark: "",
        paymentName: "",
        clientId: "",
      },
      formRules: {
        date: [
          {
            required: true,
            validator: validatePass
          }
        ],
        dateHour: timeRules_H,
        dateMin: timeRules_M,
        productValue: [ {
          required: true,
          message: this.$locale("trans.report.stand.plsSelectProduct")
        } ],
        unitPrice: [ {
          required: true,
          message: this.$locale("trans.other.plsInputUnitPrice")
        } ],
        price: [ {
          required: true,
          message: this.$locale("trans.other.plsInputQuantity")
        } ],
        // paymentName: [ {
        //   required: true,
        //   message: this.$locale("trans.other.selectPaymentName")
        // } ],
        clientId: [ {
          required: true,
          message: this.$locale("accountReceivable.require.client"),
          trigger: "blur"
        } ],
        quantity: [ {
          required: true,
          message: this.$locale("trans.other.quantity")
        } ]
      },
      count: 0,
      isOpen: false,
      taxRatesMap,
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
      printObj: {
        popTitle: this.$locale("sideMenu.reports.otherTransaction"),
        id: "print",
      },
      comClientList: [],
    };
  },
  methods: {
    openDialog(type, transactionId, transactionItemId) {
      this.toggle(type);
      if(transactionId && transactionItemId) {
        this.setDetailData(transactionId, transactionItemId);
      }
    },
    filter(value) {
      this.filters = value.taxRateGp;
      this.getHistoryList();
      // let keys = Object.keys(value);
      // let [ type ] = keys;
      // this.filterType = type;
      // this.filters = value[type];
      // this.getList(this.searchValue, this.sort, this.filterType, this.filters, 0);
      // this.$refs["child"].$refs.page.internalCurrentPage = 1;
    },
    sort_fn({ prop, order }) {
      this.sort = order;
      this.getHistoryList();
    },
    productOnChange(e) {
      let { price, taxRate } = e;

      this.modalData.unitPrice = price;
      this.modalData.taxRate = taxRate;
      if (this.modalData.quantity !== null) {
        this.modalData.price = this.modalData.quantity * price;
      }

    },
    validateHandler(val) {
      this.modalData.quantity = NumberVa(val)
    },
    quantityOnChange(quantity) {
      if (this.modalData.productValue.hasOwnProperty("price")) {
        this.modalData.price = quantity * this.modalData.unitPrice;
      }
    },
    unitPriceOnChange(unitPrice) {
      if (this.modalData.quantity !== null) {
        this.modalData.price = unitPrice * this.modalData.quantity;
      }
    },
    getFormOption() {
      let reqPaymentTypeParam = {
        cinemaId: this.cinemaId,
        page: 0,
        size: 9999,
        forPos: true
      };
      requestAll([getOtherRevenueList(this.cinemaId), getPaymentTypeList(reqPaymentTypeParam)]).then(res => {
        if (res[0].success) {
          let productArr = [];
          res[0].data.data.forEach(item => {
            productArr.push({ text: item.name, value: item.id, price: item.price, taxRate: item.taxRate });
          });
          this.table[2].arr = productArr;
          this.productNameArr = productArr;
        }

        if (res[1].success) {
          let paymentArr = [];
          res[1].data.data.forEach(item => {
            if(item.type == "cash" || item.type == "creditCard" || item.type == "gmo") {
              paymentArr.push({ label: item.nameShow, value: item.id });
            }
          });
          this.originPaymentName = res[1].data.data;
          this.paymentName = paymentArr;
        }
      });
    },
    getFilterArr(type) {
      switch (type) {
      case "productType":
        return this.productNameArr;
      case "taxRateType":
        return this.taxRateArr;
      default:
        break;
      }
    },
    getDate(obj) {
      this.timeValue1 = obj.startDate;
      this.timeValue2 = obj.endDate;
    },
    getDatePopup(obj) {
      this.modalData.date = obj;
    },
    formatDate(timestamp) {
      return moment(timestamp).format("YYYY-MM-DD");
    },
    getHistoryList(_page) {
      const requestParam = {
        startDate: this.formatDate(this.timeValue1),
        endDate: this.formatDate(this.timeValue2),
        cinemaId: this.cinemaId,
        page: _page || 0,
        pageSize: 10,
        searchId: this.searchInput.replace(' ', ''),
        ...this.sort ? { sort: this.sort === "ascending" ? "ASC" : "DESC" } : {},
        ...this.filters ? { taxRate: this.filters } : {},
      };

      getOtherRevenueReport(requestParam).then(res => {
        if (res.success) {
          this.count = res.data.count;
          this.tableData = this.timeFormat(res.data);

        }
      });
    },
    submitCreateDialog() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const createTime = this.modalData.date + this.modalData.dateHour * 3600000 + this.modalData.dateMin * 60000;
          const requestParam = {
            cinemaId: this.cinemaId,
            transactionCreateTime: createTime,
            otherRevenueId: this.modalData.productValue.value,
            qty: this.modalData.quantity || 0,
            groupId: "",
            saleGroupId: "",
            unitPrice: this.modalData.unitPrice || 0,
            totalAmount: this.modalData.price || 0,
            paymentTypeId: this.modalData.paymentName,
            userId: this.accountId,
            comment: this.modalData.remark,
            clientId: this.modalData.clientId,
            ...this.type === "edit" ? {
              searchId: this.detailData.searchId,
              transactionId: this.detailData.transactionId,
              transactionItemId: this.detailData.transactionItemId,
            } : {},
          };

          if (this.type === "create") {
            createNewOtherRevenueRecord(requestParam).then(res => {
              if(res.success) {
                // this.$alert(this.$locale("global.createSuccessfully"));
                // this.getHistoryList();
                countDownAlert({
                  content: this.$locale("global.createSuccessfully"),
                  callback: this.getHistoryList,
                });
              }
            });
          } else {
            this.deleteRow(this.detailData, requestParam);
          }

        } else {
          return false;
        }
      });
    },
    search() {
      /// has not implement search functions correctly
      this.tableData = [];
      this.getHistoryList();
    },
    toggle(type) {
      this.modalData = JSON.parse(JSON.stringify(this.defaultModalData));
      this.detailData = {};

      this.isOpen = !this.isOpen;
      if (type) {
        this.type = type;
      } else {
        this.type = "";
      }

      if (!this.isOpen) {
        this.$refs.ruleForm.resetFields();
      }
      // index && (this.transIndex = index - 1)
    },
    setDetailData(_transactionId, _transactionItemId) {
      let requestParam = {
        transactionId: _transactionId,
        transactionItemId: _transactionItemId
      };

      getOtherRevenueRecordDetail(requestParam).then(res =>{
        // const PlatForm = {
        //   "pos": "POS",
        //   "selfCashier": "SELFCASHIER",
        //   "pwa": "ONLINE",
        //   "cms": "CMS",
        //   "app": "APP"
        // };
        this.detailData = res.data;
        this.detailData.transactionCreateTime = moment(this.detailData.transactionFinishTime).format("YYYY-MM-DD HH:mm");
        this.detailData.paymentName = this.getPaymentName(this.detailData.paymentTypeId);
        this.detailData.productName = this.getProductName(this.detailData.otherRevenueId);
        // this.detailData.userName = PlatForm[res.data.platform] + "/" + window.localStorage.getItem("userName");
        this.modalData.dateHour = this.$moment(this.detailData.transactionCreateTime).format("H");
        this.modalData.dateMin = this.$moment(this.detailData.transactionCreateTime).format("m");
        if (this.type === "edit") {
          this.modalData.dateHour = parseInt(this.$moment(this.detailData.transactionCreateTime).format("H"));
          this.modalData.dateMin = parseInt(this.$moment(this.detailData.transactionCreateTime).format("m"));
          this.modalData.productValue = {
            price: 0,
            taxRate: res.data.taxRate,
            text: this.productNameArr.filter(item => item.value === res.data.otherRevenueId),
            value: res.data.otherRevenueId,
          };
          this.modalData.quantity = this.detailData.qty;
          this.modalData.unitPrice = this.detailData.unitPrice;
          this.modalData.price = this.detailData.totalAmount;
          this.modalData.paymentName = this.detailData.paymentTypeId;
          this.modalData.clientId = this.detailData.clientId || "";
        }
      });
    },
    setStartTime(value) {
      this.timeValue1 = moment(value).format("YYYY-MM-DD");
    },
    setEndTime(value) {
      this.timeValue2 = moment(value).format("YYYY-MM-DD");
    },
    getPaymentName(paymentTypeId) {
      let name = "";
      this.paymentName.forEach(item => {
        if(item.value == paymentTypeId) {
          name = item.label;
        }
      });
      return name;
    },
    getProductName(otherRevenueId) {
      let name = "";
      this.productNameArr.forEach(item => {
        if(item.value == otherRevenueId) {
          name = item.text;
        }
      });
      return name;
    },
    exportCsv() {
      exportCSV_fn(this.table, this.tableData, this.timeValue1, timeValue2, weekLocaleArray);
    },
    printData() {
      exportToPrint(this.$refs.father.$el, "取引履歴（その他営業収入）", "2021-08-30");
    },
    pageChange(value) {
      this.getHistoryList(value - 1);
    },
    timeFormat(res) {
      let arr = res.records || [];
      for (let i = 0; i < arr.length; i++) {
        arr[i].transactionCreateTime = moment(arr[i].transactionCreateTime).format("YYYY-MM-DD HH:mm");
        arr[i].taxRate = taxRatesMap[arr[i].taxRate];
      }
      return arr;
    },
    dateDisableDate(time) {
      const _today = this.$moment().startOf("day").valueOf();
      const _curTime = this.$moment(time.getTime()).startOf("day").valueOf();
      return _curTime > _today;
    },
    deleteRow(row, requestParam) {
      let confirmHtml = this.type ? "<i class=\"egl-confirm-question\">?</i><span class=\"result-text\">" +
        this.$locale("trans.update.tips") +
        "</span>" :
        "<i class=\"egl-confirm-question\">?</i><span class=\"result-text\">" +
        row.otherRevenueName + this.$locale("version.screen.action.del") +
        "</span>";
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          if (this.type === "edit") {
            updateOtherRevenueRecordService(requestParam).then(() => {
              this.toggle();
              this.getHistoryList();
            });
          } else {
            delProductSalesReportService({
              itemId: row.transactionItemId,
              transactionId: row.transactionId,
              userId: window.localStorage.getItem("accountId")
            }).then(() => {
              this.search();
            });
          }
        });
    }

  },
  watch: {
    modalData: {
      handler(nv) {
        if (nv.clientId) {
          getClientListService({
            ids: this.modalData.clientId,
            page: 0,
            pageSize: 9999,
            field: ["id", "name"]
          }).then(res => {
            if (res.data && res.data.data.length > 0) {
              this.comClientList = this.$_.uniqBy(res.data.data.concat(this.comClientList), "id");
              // this.$refs["selectV2"].page = 0;
              // if (this.form.targetSourceList.clientIdList.length === 0) this.$refs["selectV2"].page++;
            }
          });
        }
      },
      immediate: true,
      deep: true,
    }
  }
};
</script>
